<template>
  <div class="flex flex-col flex-1">
    <BaselineList
      :resource-id="resourceId"
      :resource="resource"
      :disabled="disabled"
      @refresh="handleRefresh"
    />
    <!-- <MDivider class="mt-0" /> -->
    <VarianceList
      ref="varianceListRef"
      :resource-id="resourceId"
      :resource="resource"
      :disabled="disabled"
      @refresh="$emit('refresh')"
    />
  </div>
</template>
<script>
import BaselineList from './baseline-list'
import VarianceList from './variance-list'
export default {
  name: 'SummaryTab',
  components: {
    BaselineList,
    VarianceList,
  },
  props: {
    resourceId: { type: Number, required: true },
    resource: { type: Object, required: true },
    disabled: { type: Boolean, defalut: false },
  },
  data() {
    return {}
  },
  methods: {
    handleRefresh() {
      this.$emit('refresh')
      this.$refs.varianceListRef.refresh()
    },
  },
}
</script>
